export const HCA_PLAYLISTS_ORG_ID = "75a99644-d769-11ec-8330-069463faa5ff";

export function getPlaylistsIndexName(orgId) {
	return `prod_PLAYLISTS_${orgId}`;
}

export function getPlaylistsV2IndexName(orgId) {
	return `prod_PLAYLISTS_V2_${orgId}`;
}
